// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyBaYiGITUW4AZBMnpO6I5vKnWFpNjBPL-Q",
    authDomain: "ddbwebsite-f89ac.firebaseapp.com",
    databaseURL: "https://ddbwebsite-f89ac.firebaseio.com",
    projectId: "ddbwebsite-f89ac",
    storageBucket: "ddbwebsite-f89ac.appspot.com",
    messagingSenderId: "469736426828"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
